module.exports = __webpack_public_path__ + "static/media/c19.03e2e46c.png";